<template>
    <AdminPage/>
</template>

<script>
// @ is an alias to /src
import AdminPage from '@/components/AdminPage.vue'

export default {
  name: 'AdminView',
  components: {
    AdminPage
  }
}
</script>
